import RepositoryItem from './repositoryItem';

export default RepositoryItem;
